/**
 * 目前防刷机制中，服务端是直接维护了混淆后的sign脚本，收到请求后直接返回的，callbak是个固定值，所以前端将计算出的sign放入一个队列中
 */
var signQueue = [];

if (typeof window.callback_1598411730827 === 'function') {
  console.warn('gs callback 占用！');
}

window.callback_1598411730827 = function (sign) {
  signQueue.push(sign);
};

function gs(src) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');

    if (!src) {
      return reject(new Error('gs() need src'));
    }

    script.onerror = function () {
      reject(new Error('load script faild'));
    }; // onload的时机是在script的内容执行之后，此时callback_1598411730827已经被执行，正常情况下，signQueue中已经有了值


    script.onload = function () {
      if (signQueue.length > 0) {
        resolve(signQueue.shift());
      } else {
        reject(new Error('signQueue is empty!'));
      } // 脚本从dom树上面移除自己


      script.parentNode && script.parentNode.removeChild(script);
    };

    script.src = src;
    document.head.appendChild(script);
  });
}

export { gs as default };
